function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 392.533 392.533",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M340.428,370.618c6.012,0,10.925-4.848,10.925-10.925V211.717c0-6.012-4.848-10.925-10.925-10.925 H52.105c-6.012,0-10.925,4.848-10.925,10.925v147.976c0,6.012,4.848,10.925,10.925,10.925H340.428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#56ACE0"
    },
    d: "M62.966,222.642v43.83h56.824c6.012,0,10.925,4.848,10.925,10.925 c0,6.012-4.848,10.925-10.925,10.925H62.966v21.721h34.909c6.012,0,10.925,4.848,10.925,10.925c0,6.012-4.848,10.925-10.925,10.925 H62.966v16.937h266.602v-126.19H62.966z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC10D"
    },
    d: "M196.267,21.657c-59.41,0-107.766,48.356-107.766,107.766v49.519h21.786v-49.519 c0-47.451,38.529-85.98,85.98-85.98c43.766,0,79.968,32.84,85.333,75.119h21.915C298.02,64.194,252.057,21.657,196.267,21.657z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M214.949,267.119c0-10.279-8.339-18.683-18.683-18.683c-10.279,0-18.683,8.339-18.683,18.683 c0,10.279,8.339,18.683,18.683,18.683C206.545,285.802,214.949,277.398,214.949,267.119z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M196.267,226.78c-22.303,0-40.469,18.166-40.469,40.469c0,18.554,12.541,34.133,29.608,38.917 v27.798c0,6.012,4.848,10.925,10.925,10.925s10.925-4.849,10.925-10.925v-27.798c17.067-4.784,29.608-20.428,29.608-38.917 C236.735,244.945,218.57,226.78,196.267,226.78z M196.267,285.996c-10.279,0-18.683-8.339-18.683-18.683 c0-10.279,8.339-18.683,18.683-18.683c10.279,0,18.683,8.339,18.683,18.683C214.949,277.527,206.545,285.996,196.267,285.996z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M340.428,179.2H132.073v-49.519c0-35.362,28.832-64.194,64.194-64.194s64.194,28.832,64.194,64.194 c-0.259,5.689,5.107,11.313,10.925,10.925h43.572c6.012,0,10.925-4.848,10.925-10.925C325.947,58.182,267.766,0,196.267,0 S66.586,58.182,66.586,129.616v49.519H52.105c-18.036,0-32.711,14.675-32.711,32.711v147.976c0,18.036,14.675,32.711,32.711,32.711 h288.323c18.036,0,32.711-14.675,32.711-32.711V211.846C373.139,193.875,358.529,179.2,340.428,179.2z M88.501,129.552 c0-59.41,48.356-107.766,107.766-107.766c55.79,0,101.754,42.602,107.248,96.905H281.6c-5.43-42.279-41.568-75.119-85.333-75.119 c-47.451,0-85.98,38.529-85.98,85.98v49.519H88.501V129.552z M351.354,359.822c0,6.012-4.848,10.925-10.925,10.925H52.105 c-6.012,0-10.925-4.848-10.925-10.925V211.846c0-6.012,4.848-10.925,10.925-10.925h288.323c6.012,0,10.925,4.848,10.925,10.925 V359.822z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccess);
export default __webpack_public_path__ + "static/media/Access.52fad3c2.svg";
export { ForwardRef as ReactComponent };